module.exports = __webpack_public_path__ + "img/wheat@2x.png";